import React from 'react';
import ReactDOM from 'react-dom';

// Import Vendors Styles
import 'styles/vendors/_vendors.scss';
// Import the main React App Component
import Root from 'containers/Root';
// Import the configured store
import storeConfig from 'store';
// Import the main index styles
import styles from './index.module.scss';

// Grab the #root element
const rootElement = document.getElementById('root');
// Add in our 'root' classname, modified via css-modules
rootElement.classList.add(styles.root);

// Render to the DOM
ReactDOM.render(<Root {...storeConfig} />, rootElement);
